// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"98":"fcc44929","319":"a37a51d3","458":"63e5066d","530":"63e5066d","745":"596d9211"}[chunkId] + ".chunk.css";
};